import { AppRouteProps } from "@harea/component";
import React from "react";
import { DetailsRoutes } from "./views/details/DetailsRoutes";
import { ParamsMyAccountRoutes } from "./views/params/ParamsMyAccountRoutes";

const MyAccountContainer = React.lazy(() => import("./container/MyAccountContainer"))

export const MyAccountRoutes: Array<AppRouteProps> = [
    {
        path: "my-account",
        element: <MyAccountContainer />,
        children: [
            ...DetailsRoutes,
            ...ParamsMyAccountRoutes
        ]
    },
]
